<template>
    <div class="table-wrapper" style="padding-top: 20px;">
        <Form ref="formInline" :model="formInline" inline
            :label-width="100" label-position="right">
            <div class="search-right-wrapper">
                <Button :loading="eLoading" type="primary" style="float:left;" @click="handleExport" icon="ios-exit-outline">导出</Button>
                <FormItem label="时间选择:">
                    <DatePicker type="daterange" v-model="formInline.time" split-panels placeholder="请选择" @on-change="timeChange" ></DatePicker>
                </FormItem>
                <FormItem label="推送目的地:"  style="width:286px;text-align:left;">
                    <Select v-model="exportData.targetName" clearable>
                        <Option v-for="item in targets" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <Button style="margin-left: 20px;float:right;" @click="handleReset">重置</Button>
                <Button style="float: right;" type="primary" @click="getTableData">搜索</Button>
            </div>
        </Form>
        <Table :loading="loading" border :columns="tableColumns" :data="tableData" highlight-row>
            <template slot-scope="{ row, index }" slot="action">
                <span class="pointer" type="text" size="small" @click="handleDeal('dataPushList', row)">详情</span>
            </template>
        </Table>
        <div class="t-page">
            <Page :total="totalCount" :page-size="exportData.pageSize" :current="exportData.page"
                @on-change="changePage" @on-page-size-change="pageSizeChange"
                show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                targets: [],
                formInline:{
                    startDate:'',
                    endDate:'',
                    time: []
                },
                formOutLine1: {
                    startDate:'',
                    endDate:''
                },
                tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '数据推送目的地',
                        key: 'targetName',
                        minWidth:100,
                    },
                     {
                        title: '数据末次推送时间',
                        key: 'lastPushTime',
                        minWidth:150,
                        align: 'right'
                    },
                    {
                        title: '数据总条数',
                        key: 'dataTotalCount',
                        minWidth:150,
                        align: 'right'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        align: 'center',
                        width: 100
                    }
                ],
                tableData:[],
                exportData:{
                    pageSize: 10,
                    page: 1,
                    targetName: ''
                }
            };
        },
        computed:{
            ...mapState(['areaCode']),
        },
        created(){

        },
        mounted(){
            this.getTargets()
        },
        watch: {

        },
        methods: {
            handleReset() {
                this.page = 1
                this.formInline = {
                    startDate:'',
                    endDate:'',
                    time: []
                }
                this.exportData.page = 1
                this.exportData.targetName = ''
                this.getTableData()
            },
            getTargets() {
                this.axios({
                    method: 'get',
                    url:'/dataPush/targetNames'
                }).then( (response)=> {
                    response.data.data.map(item => {
                        this.targets.push({
                            value: item,
                            label: item
                        })
                    })
                });
            },
            pageSizeChange(val) {
                this.exportData.pageSize = val
                this.getTableData()
            },
            changePage(val){
                this.exportData.page = val
                this.getTableData()
            },
            timeChange(val) {
                this.formInline.startDate = val[0]
                this.formInline.endDate = val[1]
            },
            //导出
            handleExport(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    pageSize:this.exportData.pageSize,
                    startNum:this.exportData.page,
                    targetName: this.exportData.targetName,
                    areaCode: localStorage.getItem('tenantAreaCode')
                };
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/dataPush/export',
                    responseType:'arraybuffer',
                    data: param
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response, '数据推送.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name, row){
                this.$router.push({
                    name: name,
                    query: {
                        targetName: row.targetName
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    startDate: this.formInline.startDate,
                    endDate: this.formInline.endDate,
                    pageSize:this.exportData.pageSize,
                    startNum:this.exportData.page,
                    targetName: this.exportData.targetName,
                    areaCode: localStorage.getItem('tenantAreaCode')
                };
                // this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/dataPush/list',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData=response.data.data.list
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
<style scoped >
    .dataTab .ivu-tabs-bar {
        margin-bottom: 0;
        border-bottom: none;
    }
</style>
